import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import {
    MDBBtn,
    MDBModalFooter,
} from "mdb-react-ui-kit";

export default function RemoveBlfUser(props) {
    console.log("props :::::::::: " + JSON.stringify(props));
    const { t, i18n } = useTranslation();
    return (
        <>
            {props.userInfo.devices ? (
                <div>
                    {t("deleteuserConfirm", {
                        Username: `${props.userInfo?.name}`,
                        macAdress: `(${props.userInfo?.devices})`
                    })}
                </div>
            ) : (
                <div>
                    {t("RemoveBlfUserText")} {props.userInfo?.name}
                </div>
            )}

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => props.onsave(props.userInfo)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </>
    )
}
